import { HaircutDto } from './HaircutDto';

export class HaircutPreload {
  rows: Array<HaircutDto>;
  currencies: Array<string>;
}
